import { createContext, useContext } from 'react';

export const PageRefreshContext = createContext<() => void>(() => {});
export const usePageRefresh = () => useContext(PageRefreshContext);
